export default function Banner(){
    return (
        <div className="relative w-full overflow-hidden hidden md:block bg-gradient-to-r from-green-100 via-green-400 to-green-900 text-gray-900">
    <div className="flex items-center justify-end whitespace-nowrap">
        <div className="flex space-x-8 px-4 py-4">
            <p className="inline-block text-white font-Raleway text-sm"> 
                +254 716 152699 | info@lapa.africa | Nairobi, Kenya.
            </p>
        </div>
        <div className="flex space-x-4 mr-4">

                </div>
    </div>
</div>
    )
}